<template>
  <div class="smart-construction">
    <HeaderStyles1>
      <h1 slot="title" v-html="$t('smart-construction-head-h1')"></h1>
      <p slot="detail" v-html="$t('smart-construction-head-small')"></p>
      <b-img class="platform-title-img" slot="image" src="../assets/imgs/head-img-smart-construction.png" alt="" />
    </HeaderStyles1>

    <b-container fluid="xl" class="main-content">

      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-1-title')}}</h1>
        <b-row class="mt-5">
          <b-col sm="6" md="5" xl="5" order="2">
            <p class="section-2-text" v-html="$t('smart-construction-section-1-content')"></p>
          </b-col>
          <b-col sm="6" md="7" xl="7" :order="isMobile ? 1 : 3">
            <b-img fluid-grow src="../assets/imgs/smart-construction-section-1-img.png"></b-img>
          </b-col>
        </b-row>
      </section>

      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-2-title')}}</h1>
        <b-row class="mt-5">
          <b-col sm="6" md="7" xl="7">
            <b-row>
              <b-col>
                <b-img fluid-grow src="../assets/imgs/smart-construction-section-2-phone1.png"></b-img>
              </b-col>
              <b-col>
                <b-img fluid-grow src="../assets/imgs/smart-construction-section-2-phone2.png"></b-img>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="6" md="5" xl="5">
            <p class="section-2-text" v-html="$t('smart-construction-section-2-content')"></p>
          </b-col>
        </b-row>
      </section>

      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-3-title')}}</h1>
        <b-row class="mt-5">
          <b-col sm="6" md="5" xl="5" order="2">
            <p class="section-2-text" v-html="$t('smart-construction-section-3-content')"></p>
          </b-col>
          <b-col sm="6" md="7" xl="7" :order="isMobile ? 1 : 3">
            <b-row>
              <b-col><b-img fluid-grow src="../assets/imgs/smart-construction-section-3-phone1.png"></b-img></b-col>
              <b-col><b-img fluid-grow src="../assets/imgs/smart-construction-section-3-phone2.png"></b-img></b-col>
              <b-col><b-img fluid-grow src="../assets/imgs/smart-construction-section-3-phone3.png"></b-img></b-col>
            </b-row>
            <p class="section-3-under-img-text">{{$t('smart-construction-section-3-small')}}</p>
          </b-col>
        </b-row>
      </section>

      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-3-title')}}</h1>
      </section>
      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-4-title')}}</h1>
      </section>
      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-5-title')}}</h1>
      </section>
      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-6-title')}}</h1>
      </section>
      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-7-title')}}</h1>
      </section>
      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-8-title')}}</h1>
      </section>
      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-9-title')}}</h1>
      </section>
      <section class="page-section">
        <h1 class="section-title">{{$t('smart-construction-section-10-title')}}</h1>
      </section>
    </b-container>

  </div>
</template>
<script>
import HeaderStyles1 from '../components/HeaderStyles1.vue'
import runtime from '../utils/runtime'

export default {
  name: 'Smart Construction',
  components: {
    HeaderStyles1
  },
  data () {
    return {
      isMobile: runtime.isMobile()
    }
  }
}
</script>
<style lang="less">
  .smart-construction {
    overflow-x: hidden;
    .platform-title-img {
      max-width: 50% !important;
      bottom: 30px !important;
      right: 30px !important;
    }

    .page-section {
      margin-top: 90px;

      .section-title {
        font-size: 34px;
        font-weight: 700;
        color: #000000;
        margin-bottom: 60px;
      }

      .section-2-text {
        padding: 20px;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.4;
        color: #ffffff;
        background-color: #6C63FF;
      }

      .section-3-under-img-text {
        width: 80%;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        text-align: center;
        margin: 20px auto;
      }
    }
  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .smart-construction {
      .page-section {
        margin-top: 30px;
        .section-title {
          font-size: 18px;
          text-align: center;
          margin-bottom: 18px;
        }

        .section-2-text {
          margin-top: 30px;
          font-size: 12px;
        }
      }
    }
  }
</style>
